
import React from "react";
import { 
  HelpCircle,
  FileText,
  Calendar,
  CreditCard,
  Building,
  User,
  Heart,
  Gift,
  Layers,
  Target,
  BookOpen,
  BookMarked,
  BookOpen as BookOpenIcon,
  MapPin,
  Building2 
} from "lucide-react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { ScrollArea } from "@/components/ui/scroll-area";

export function ClientFieldsGuide() {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" size="sm">
          <HelpCircle className="mr-2 h-4 w-4" />
          Client Fields Guide
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[350px]" align="end">
        <div className="space-y-4">
          <div className="flex items-center">
            <FileText className="h-5 w-5 mr-2 text-muted-foreground" />
            <h4 className="text-sm font-semibold">Client Fields Guide</h4>
          </div>
          
          <Separator />
          
          <ScrollArea className="h-[400px] pr-4">
            <div className="space-y-4">
              {/* Basic Information */}
              <div>
                <h5 className="text-sm font-semibold mb-2 flex items-center">
                  <Building className="h-4 w-4 mr-2 text-muted-foreground" />
                  Basic Information
                </h5>
                <ul className="space-y-2 text-sm">
                  <li><strong>Industry:</strong> The client's primary industry sector</li>
                  <li><strong>Status:</strong> Active, Inactive, or Prospect</li>
                  <li><strong>Tier:</strong> Client classification (Enterprise, Premium, Standard, Basic)</li>
                  <li><strong>Client Type:</strong> Type of client relationship</li>
                  <li><strong>Referral Source:</strong> How the client was acquired</li>
                </ul>
              </div>
              
              {/* Contract Information */}
              <div>
                <h5 className="text-sm font-semibold mb-2 flex items-center">
                  <CreditCard className="h-4 w-4 mr-2 text-muted-foreground" />
                  Contract Information
                </h5>
                <ul className="space-y-2 text-sm">
                  <li><strong>Contract Value:</strong> Total contract value in USD</li>
                  <li><strong>Monthly Retainer:</strong> Monthly recurring revenue</li>
                  <li><strong>Retainer Type:</strong> Type of retainer agreement</li>
                  <li><strong>Start Date:</strong> Contract start date</li>
                  <li><strong>Renewal Date:</strong> Contract renewal deadline</li>
                  <li><strong>Reporting Cycle:</strong> Frequency of client reporting</li>
                </ul>
              </div>
              
              {/* Social Media */}
              <div>
                <h5 className="text-sm font-semibold mb-2 flex items-center">
                  <Layers className="h-4 w-4 mr-2 text-muted-foreground" />
                  Social Media
                </h5>
                <ul className="space-y-2 text-sm">
                  <li><strong>Instagram:</strong> Instagram handle/profile</li>
                  <li><strong>Facebook:</strong> Facebook page name</li>
                  <li><strong>LinkedIn:</strong> LinkedIn company page</li>
                  <li><strong>TikTok:</strong> TikTok handle</li>
                </ul>
              </div>
              
              {/* Client Preferences */}
              <div>
                <h5 className="text-sm font-semibold mb-2 flex items-center">
                  <Heart className="h-4 w-4 mr-2 text-muted-foreground" />
                  Client Preferences
                </h5>
                <ul className="space-y-2 text-sm">
                  <li><strong>Personality:</strong> Client communication style preferences</li>
                  <li><strong>Gift Preferences:</strong> Gift preferences for holidays/occasions</li>
                  <li><strong>Gender Preference:</strong> Point of contact gender preference</li>
                </ul>
              </div>
              
              {/* Organization Structure */}
              <div>
                <h5 className="text-sm font-semibold mb-2 flex items-center">
                  <Building2 className="h-4 w-4 mr-2 text-muted-foreground" />
                  Organization Structure
                </h5>
                <ul className="space-y-2 text-sm">
                  <li><strong>Org Mapping:</strong> Key stakeholders and organizational structure</li>
                  <li><strong>Org Chart Notes:</strong> Notes on decision-makers and influence</li>
                </ul>
              </div>
              
              {/* Client Goals */}
              <div>
                <h5 className="text-sm font-semibold mb-2 flex items-center">
                  <Target className="h-4 w-4 mr-2 text-muted-foreground" />
                  Client Goals
                </h5>
                <ul className="space-y-2 text-sm">
                  <li><strong>Client Goals:</strong> Strategic client objectives and qualitative goals</li>
                </ul>
              </div>
            </div>
          </ScrollArea>
        </div>
      </PopoverContent>
    </Popover>
  );
}
